module.exports = __webpack_public_path__ + "static/media/btn-deportes.9a507f18.png";